/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ lines: NonNullable<unknown>, customers: NonNullable<unknown> }} Admin_Export_Usage_SummaryInputs */



/**
* | output |
* | --- |
* | "{lines} lines · {customers} customers" |
*
* @param {Admin_Export_Usage_SummaryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_export_usage_summary = /** @type {((inputs: Admin_Export_Usage_SummaryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Export_Usage_SummaryInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.lines} Zeilen · ${i?.customers} Kunden`)
	return /** @type {LocalizedString} */ (`${i?.lines} lines · ${i?.customers} customers`)
});